

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import UserHeaderFields from "./CaseDetails/Users/UserHeaderFields.vue"
const caseStore = namespace("cases")

@Component({
	components: {
		"user-header-fields": UserHeaderFields
	}
})
export default class UserImage extends Vue {
	@caseStore.Getter("getCurrentCase") public currentCase: any;

	@Getter("getUserPictureUrl")
	public userPictureUrl!: (user: { id: string}) => string;

	@Action
	public loadUserPictureUrl!: (user: { id: string}) => Promise<string>;

	@Prop({ type: String, default: "md" })
	public size!: string;

	@Prop()
	public user: any;

	@Prop({ type: Boolean, default: false })
	public showUserName!: boolean;

	@Prop({ type: Boolean, default: false })
	public showTeams!: boolean;

	@Prop({ type: Boolean, default: false })
	public showEmail!: string;

	@Prop({ type: Boolean, default: false })
	public showHeaderFields!: boolean;

	@Prop({ type: Boolean, default: false })
	public usernamePopup!: boolean;

	@Prop({ type: String, default: "id" })
	public userIdField!: string;

	@Prop({ default: () => null })
	public fetchUserPictureUrl!: null | ((id: string) => string)

	isLoaded: boolean = false;
	pictureError: boolean = false;
	pictureUrl: string | null = null;

	@Watch("user")
	onUserChanged (newUser: any, oldUser: any) {
		if (!newUser || !oldUser || newUser.id !== oldUser.id) {
			this.pictureError = false
			this.pictureUrl = null
			this.isLoaded = false
		}
	}

	public get userPicture (): string | null {
		if (this.pictureError) {
			return "images/blank_user.png"
		}

		if (this.pictureUrl) {
			this.isLoaded = true
			return this.pictureUrl
		}

		if (this.user) {
			if (this.user.isExternal) {
				return "images/blank_user.png"
			}
			if (this.user.pictureUrl) {
				return this.user.pictureUrl
			}

			if (!this.user[this.userIdField]) {
				return this.pictureUrl = "images/system_user.png"
			}

			const userId = this.user[this.userIdField]

			const cachedPictureUrl = this.userPictureUrl(userId)
			if (cachedPictureUrl) {
				return this.pictureUrl = cachedPictureUrl
			}

			if (this.fetchUserPictureUrl) {
				this.pictureUrl = this.fetchUserPictureUrl(userId)
			} else {
				this.loadUserPictureUrl(userId).then((pictureUrl: string) => {
					this.pictureUrl = pictureUrl
				})
			}

			return this.pictureUrl
		} else {
			return this.pictureUrl = "images/system_user.png"
		}
	}

	public loadedImage () {
		this.isLoaded = true
	}

	public imageUrlError (args: any) {
		this.pictureError = true
	}
}

